import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.754 0c.73 0 1.375.645 1.375 1.375v.86c3.137.6 5.5 3.394 5.5 6.703v.816c0 2.02.73 3.996 2.062 5.5l.301.344c.387.43.473.988.258 1.504-.215.472-.73.773-1.246.773h-16.5c-.559 0-1.074-.3-1.29-.773a1.39 1.39 0 0 1 .259-1.504l.3-.344c1.332-1.504 2.106-3.48 2.106-5.5v-.816c0-3.31 2.363-6.102 5.5-6.704v-.859C8.379.645 8.98 0 9.754 0m1.934 21.227c-.516.515-1.204.773-1.934.773s-1.461-.258-1.977-.773c-.515-.516-.773-1.247-.773-1.977h5.5c0 .73-.3 1.46-.816 1.977"
    }, null, -1)
  ]))]))
}
export default { render: render }